import { useWatch } from '@kanda-libs/ks-component-ts';
import { useEnquiryContext } from 'pages/Enquiry/context';
import { useMemo } from 'react';
import { EnquiryContactDetailsFormValues } from '../useEnquiryContactDetailsForm';

export interface EnquiryContactDetailsFormContactFieldsHook {
  tradingName: string;
  disabled: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
}

export default function useEnquiryContactDetailsFormContactFields(): EnquiryContactDetailsFormContactFieldsHook {
  const { tradingName, isLoading, isSubmitting } = useEnquiryContext();

  const value = useWatch<
    EnquiryContactDetailsFormValues,
    'terms.agreed_terms.value'
  >({
    name: 'terms.agreed_terms.value',
  });

  const disabled = useMemo(() => !value, [value]);

  return {
    tradingName,
    disabled,
    isLoading,
    isSubmitting,
  };
}
